require('./resultsController');

"use strict";

angular.module('app.purchase.results', [
    'app.purchase.results.resultsController'
])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('app.purchase.results', {
                url: '/purchase/billing_info/:result',
                templateUrl: 'components/purchase/results/resultsView.html',
                controller: 'app.purchase.results.resultsController',
                title: 'Billing Information',
                params: {
                    message: null
                }
            })
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/purchase/results/results.js